import { render } from "./enrolment-export.vue?vue&type=template&id=0887ec6c&ts=true"
import script from "./enrolment-export.ts?vue&type=script&lang=ts&external"
export * from "./enrolment-export.ts?vue&type=script&lang=ts&external"

import "./enrolment-export.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__